module.exports = __webpack_public_path__ + "img/seed-analyzer-logo-original.b4c5ac97.png";